import "./workspace.e021bdc9.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec702"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec702"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("bgeJJ");
parcelRequire("l2CVb");
parcelRequire("fvzOd");
/** Wait until the custom element is defined & rendered once */ async function $761f97bf09d51d3e$var$getSignUp() {
    await customElements.whenDefined('sign-up');
    const el = document.querySelector('sign-up');
    // Ensure it has rendered; its connectedCallback renders immediately,
    // but raf gives us a safe tick for shadow contents to exist.
    await new Promise((r)=>requestAnimationFrame(r));
    return el;
}
document.addEventListener('DOMContentLoaded', async ()=>{
    // Add event for the jam button
    const signUp = await $761f97bf09d51d3e$var$getSignUp();
    if (!signUp) return;
    // ——— 1) “Sign Up for Lessons!” button in the contact card
    const cardSignupBtn = document.getElementById('jam-btn');
    if (cardSignupBtn) cardSignupBtn.addEventListener('click', ()=>$761f97bf09d51d3e$var$openSignUp(signUp));
});
function $761f97bf09d51d3e$var$openSignUp(signUp) {
    if (typeof signUp.open === 'function') signUp.open();
    else {
        // fallback: toggle the class in shadow (shouldn't be needed)
        const panel = signUp.shadowRoot?.getElementById('contact-slide-panel');
        panel?.classList.add('open');
    }
}
document.addEventListener('DOMContentLoaded', function() {
    const siteTitle = document.getElementById('site-title');
    const flyingGuitar = document.getElementById('flying-guitar');
    const rockOn = document.getElementById('rock-on');
    const flameEffect = document.querySelector('.flame-effect');
    let isAnimating = false;
    siteTitle.addEventListener('click', function(e) {
        if (isAnimating) return;
        isAnimating = true;
        // Start guitar and rock-on animations immediately
        flyingGuitar.classList.add('animate');
        rockOn.classList.add('animate');
        flameEffect.classList.add('animate');
        // Reset after animation completes
        setTimeout(()=>{
            flyingGuitar.classList.remove('animate');
            rockOn.classList.remove('animate');
            flameEffect.classList.remove('animate');
            isAnimating = false;
        }, 5000);
    });
});


//# sourceMappingURL=workspace.94a3fa91.js.map
